import { Controller } from '@hotwired/stimulus';
import { Turbo } from '@hotwired/turbo-rails';

export default class ConfirmationModalController extends Controller {
  static targets = ['modalTitle', 'buttonsContainer', 'loader'];

  disconnect () {
    this.close();
  }

  close () {
    const modalFrame = document.getElementById('modal-frame-container');
    if (modalFrame) modalFrame.src = '';

    this.element.classList.remove('modal--open');
    this.element.classList.add('modal--close');
  }

  closeReload () {
    this.close();
    Turbo.visit(window.location.href, { action: 'replace' });
  }

  showLoader () {
    this.modalTitleTarget.classList.add('hidden');
    this.buttonsContainerTarget.classList.add('hidden');
    this.loaderTarget.classList.remove('hidden');
  }
}
